import React from 'react';
import PropTypes from 'prop-types';
import { MotifOption } from '../select/option/option';

/**
 * @typedef Props
 * @prop {string} message
 */
/**
 * @param {Props} props
 */
const DefaultNoResultsTemplate = ({ message }) => <MotifOption disabled>{message}</MotifOption>;

DefaultNoResultsTemplate.propTypes = {
  message: PropTypes.string
};

export { DefaultNoResultsTemplate };
